import { render } from "./SchemasTable.vue?vue&type=template&id=b75e0078"
import script from "./SchemasTable.vue?vue&type=script&lang=js"
export * from "./SchemasTable.vue?vue&type=script&lang=js"

import "./SchemasTable.vue?vue&type=style&index=0&id=b75e0078&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__